import { render, staticRenderFns } from "./BtnAprovarPertinencia.vue?vue&type=template&id=49261a1e"
import script from "./BtnAprovarPertinencia.vue?vue&type=script&lang=js"
export * from "./BtnAprovarPertinencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports